import React, { useEffect, useState } from "react";
import { ConfirmDelete, MwButton, MwSpinnerButton } from "../../ui";
import { MdOutlineAddBox } from "react-icons/md";
import { useCurrent, useDelete, useFetch } from "../../../hooks";
import ListGroupsItem from "./ListGroupsItem";
import NoDataFound from "../../ui/NoDataFound";
import { useTranslation } from "react-i18next";

const ListGroups = ({ setMode, idItemSelected, setIdItemSelected }) => {
  const [t] = useTranslation("global");
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const { data: groups, loading: loadingGroups, refreshHandler } = useFetch(
    canFetchContext
      ? `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null
  );
  const { data: resulltDelete, deleteItem } = useDelete();

  const editHandeler = (id) => {
    setIdItemSelected(id);
    setMode("Edit");
  };

  const deleteHandeler = (id) => {
    setIdItemSelected(id);
    setShowConfirmDelete(true);
  };

  const confirmDeleteHandller = () => {
    deleteItem(
      `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/groups/delete/${idItemSelected}`
    );
  };

  useEffect(() => {
    if (!resulltDelete) return;
    refreshHandler();
    setShowConfirmDelete(false);
  }, [resulltDelete, refreshHandler]);

  return (
    <>
      <ConfirmDelete
        onDeleteHandler={confirmDeleteHandller}
        msg={t("vendorGroups.confirmDelete")}
        onShow={showConfirmDelete}
        setOnShow={setShowConfirmDelete}
      />
      <div className="flex items-center">
        <div className="flex-1 font-bold text-slate-400">
          {t("vendorGroups.vendorGroupsList")}
        </div>
        <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("Add")}>
          <MdOutlineAddBox size={18} />
          <span>{t("vendorGroups.addNewGroup")}</span>
        </MwButton>
      </div>
      <div className="py-3 ">
        {!canFetchContext ? (
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        ) : !loadingGroups && groups?.data?.length > 0 ? (
          groups?.data?.map((item) => (
            <ListGroupsItem
              key={item._id}
              item={item}
              editHandeler={editHandeler}
              deleteHandeler={deleteHandeler}
            />
          ))
        ) : groups && groups?.data?.length < 1 ? (
          <NoDataFound msg={t("vendorGroups.noGroupsFound")} />
        ) : (
          <MwSpinnerButton withLabel={false} isFullCenter={true} />
        )}
      </div>
    </>
  );
};

export default ListGroups;
